import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Admin → Users: the per-tester "Answer script" switch (2026-11-04). Off by default.
// When on, a beta tester can open the answer script on their own interviews' start
// screen. It only works while the account has beta access; Free and Paid never get it.
export function AdminAnswerScriptSwitch({ userId, isAdminUser = false }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isAdminUser) return;
    api.get(`/admin/users/${userId}/answer-script`).then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, [userId, isAdminUser]);

  if (isAdminUser || !data) return null;
  const toggle = async () => {
    setBusy(true);
    try {
      const { data: d } = await api.post(`/admin/users/${userId}/answer-script`, { enabled: !data.enabled, reason: "Admin → Users" });
      setData((prev) => ({ ...prev, ...d }));
      toast.success(d.enabled ? "Answer script switched on." : "Answer script switched off.");
    } catch {
      toast.error("Couldn't change the answer script switch.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border border-[color:var(--border-stone)] p-3 text-xs space-y-2" data-testid="admin-answer-script">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-sm font-medium">Answer script</div>
          <div className="text-[color:var(--text-secondary)]">
            Lets this beta tester open the answer script (answers to read aloud, and what the interviewer should do next)
            on their own interviews. Up to 5 scripts per interview. Run it and simulations stay admin-only.
          </div>
        </div>
        <button type="button" role="switch" aria-checked={data.enabled} onClick={toggle} disabled={busy}
          className={`shrink-0 rounded-full px-4 py-1.5 text-sm ${data.enabled ? "bg-[color:var(--brand)] text-white" : "border border-[color:var(--border-stone)]"}`}
          data-testid="admin-answer-script-toggle">
          {data.enabled ? "On" : "Off"}
        </button>
      </div>
      {data.enabled && !data.works_now && (
        <div className="text-amber-800" data-testid="admin-answer-script-inactive">
          Switched on, but it won't show until this account has beta access (a Partner Code). It's never available on Free or Paid accounts.
        </div>
      )}
    </div>
  );
}
